<template>
  <div class="pages-body error-page flex flex-column">
    <div class="topbar p-3 flex justify-content-between flex-row align-items-center">
      <router-link class="topbar-left ml-3 flex" to="/">
        <div class="logo">
          <img src="/layout/images/logo.png" style="height: 3.55rem" alt=""/>
        </div>
      </router-link>
    </div>

    <div class="align-self-center mt-auto mb-auto">
      <div class="pages-panel card flex flex-column">

        <div class="success-page">
          <h1>{{ $t('success_page.title') }}</h1>
          <p style="color: darkgray;">{{ $t('success_page.description') }}</p>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'SuccessPage'
}
</script>

<style scoped>
.success-page {
  text-align: center;
  padding: 2em;
}

.success-page h1 {
  color: #808080;
}

.success-page p {
  margin-bottom: 2em;
}
</style>
